import React from 'react';
import axios from 'axios';
import {Route, Switch, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import AdminList from "./AdminList";
import AdminForm from "./AdminForm";
import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";

import './style.css';

class Admins extends React.Component {
    constructor(props) {
        super(props);

        this.handleAddAdmin = this.handleAddAdmin.bind(this);
        this.handleEditAdmin = this.handleEditAdmin.bind(this);
        this.handleRemoveAdmin = this.handleRemoveAdmin.bind(this);
    }

    handleAddAdmin(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.post(this.props.api.admins, {
            ...values
        }, config).then((response) => {
            if (!this._calledComponentWillUnmount) {
                this.props.addNotification('success', response.status, 'Administrátor ' + response.data.user.firstname + ' ' + response.data.user.surname + ' byl vytvořen.');
                this.props.history.push('/admins');
            }
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Administrátora se nepodařilo vytvořit!');
            this.props.history.push('/admins');
            console.log('Axios error:', error);
        });
    }

    handleEditAdmin(values) {
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        let data = {
            email: values.email,
            firstname: values.firstname,
            surname: values.surname,
            nickname: values.nickname,
            phoneNumber: values.phoneNumber
        };
        if (values.password !== '') data.password = values.password;
        axios.put(this.props.api.admins + "/" + values.id, {
            ...data
        }, config).then((response) => {
            this.props.addNotification('success', response.status, 'Administrátor ' + response.data.firstname + ' ' + response.data.surname + ' byl upraven.');
            this.props.history.push("/Admins");
        }).catch((error) => {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message :'Administrátora se nepodařilo upravit!');
            this.props.history.push('/admins');
            console.log('Axios error: ', error);
        });
    }

    handleRemoveAdmin(admin) {
        console.log("Remove admin");
        let loginToken = this.props.sessionData.accessToken;
        let config = {
            headers: {
                'Authorization': 'Bearer ' + loginToken
            }
        };
        axios.delete(this.props.api.users + "/" + admin.id, config)
            .then((response) => {
                if (!this._calledComponentWillUnmount) {
                    this.props.addNotification('success', response.status, 'Administrátor ' + admin.firstname + ' ' + admin.surname +' byl odstraněn.');
                }
            }).catch(function (error) {
            this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Administrátora se nepodařilo odstranit!');
            console.log('Axios error:', error);
        });
    }

    render() {
        return (
                <div id="admins-page" className="right-col" role="main">
                    <div className="page-title">
                        <h3>Administrátoři</h3>
                    </div>
                    <Switch >
                        <Route exact path="/admins" component={() =>
                            <AdminList
                                {...this.props}
                                handleRemoveAdmin={this.handleRemoveAdmin}
                            />}
                        />
                        <Route path="/admins/add" component={() =>
                            <AdminForm
                                {...this.props}
                                title="Formulář pro přidání administrátora"
                                button="Přidat"
                                action={this.handleAddAdmin}
                            />}
                        />
                        <Route path="/admins/edit/:id" component={() =>
                            <AdminForm
                                {...this.props}
                                title="Formulář pro úpravu administrátora"
                                button="Upravit"
                                action={this.handleEditAdmin}
                            />}
                        />
                    </Switch>
                </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications,
    }
};

const mapDispatchToProps = function (dispatch) {
    return {
        addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Admins));



/** WEBPACK FOOTER **
 ** ./src/containers/Admins/index.js
 **/